<div class="container-fluid">
	<div class="row">
		<div class="col-md-3">
			<full-calendar *ngIf="showCalendar" #calendarDatepicker id="calendar-sm"
				schedulerLicenseKey="0849620639-fcs-1574696857" defaultView="dayGridMonth" [plugins]="calendarDatepickerPlugins"
				[themeSystem]="'bootstrap'" [header]="calendarDatepickerHeader" [allDaySlot]="false"
				[showNonCurrentDates]="false" [navLinks]="false" (dateClick)="setDate($event.dateStr)">
			</full-calendar>
		</div>
		<div class="col-md-9 calendar-container py-4">
			<full-calendar #calendarTimeline id="calendar" [selectable]="true" [timeZone]="'UTC'" [nowIndicator]="true"
				[events]="getEvents" [resources]="getResources" [columnHeader]="true" [slotDuration]="'01:00:00'"
				[slotEventOverlap]="false" [contentHeight]="'700'" (resourceRender)="resourceRender($event)"
				(eventRender)="eventRender($event)" schedulerLicenseKey="0849620639-fcs-1574696857"
				[refetchResourcesOnNavigate]="true" defaultView="resourceTimeGridDay" [plugins]="calendarTimelinePlugins"
				[themeSystem]="'bootstrap'" [header]="calendarTimelineHeader" [allDaySlot]="false"
				[filterResourcesWithEvents]="false" (dateClick)="setDate($event.dateStr)" (dayRender)="dayRender($event)">
			</full-calendar>
		</div>
	</div>
</div>